"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortraitMobileLayout = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const base_ui_theme_spacing_1 = require("@unboared/base-ui.theme.spacing");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const DEFAULT_FLEX = { header: 0.4, content: 0.5, footer: 0.1 };
const PortraitMobileLayout = ({ header, children, footer, flex, style, headerStyle, contentStyle, footerStyle }) => {
    // const screen = useScreenInfos();
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const customFlex = Object.assign(Object.assign({}, DEFAULT_FLEX), flex);
    const layoutStyle = [styles.container, style];
    const headerStyle_ = [styles.center, headerStyle];
    const contentStyle_ = [styles.center, contentStyle];
    const footerStyle_ = [styles.center, footerStyle];
    return (react_1.default.createElement(react_native_1.View, { style: [{ padding: normalize(base_ui_theme_spacing_1.space.medium) }, layoutStyle] },
        react_1.default.createElement(react_native_1.View, { style: [headerStyle_, { flex: customFlex.header }] }, header),
        react_1.default.createElement(react_native_1.View, { style: [contentStyle_, { flex: customFlex.content }] }, children),
        footer &&
            react_1.default.createElement(react_native_1.View, { style: [footerStyle_, { flex: customFlex.footer }] }, footer)));
};
exports.PortraitMobileLayout = PortraitMobileLayout;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
    },
    center: {
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
    },
});
//# sourceMappingURL=mobile_layout.js.map